/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const o=!0,t=32,c=1.5,e=200;export{t as collisionGridCellSize,c as declutterBudget,o as declutterTiles,e as fadeDuration};
